/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowRetrieveSlugRegExp = new RegExp(
    '[-a-zA-Z0-9_]+',
);
export const validationWorkflowRetrieveNameMax = 256;

export const validationWorkflowRetrieveDescriptionMax = 1024;

export const validationWorkflowRetrieveNodeTemplatesItemSlugRegExp = new RegExp(
    '[-a-zA-Z0-9_]+',
);
export const validationWorkflowRetrieveNodeTemplatesItemNameMax = 256;

export const validationWorkflowRetrieveNodeTemplatesItemDescriptionMax = 1024;

export const ValidationWorkflowRetrieve = zod.strictObject({
    slug: zod.string().regex(validationWorkflowRetrieveSlugRegExp),
    name: zod.string().max(validationWorkflowRetrieveNameMax),
    description: zod
        .string()
        .max(validationWorkflowRetrieveDescriptionMax)
        .optional(),
    forms: zod
        .array(
            zod.strictObject({
                id: zod.number(),
                label: zod.string(),
            }),
        )
        .nullable(),
    created_by: zod.string(),
    updated_by: zod.string(),
    created_at: zod.iso.datetime({ offset: true }),
    updated_at: zod.iso.datetime({ offset: true }),
    node_templates: zod
        .array(
            zod.strictObject({
                id: zod.number(),
                order: zod.number(),
                slug: zod
                    .string()
                    .regex(
                        validationWorkflowRetrieveNodeTemplatesItemSlugRegExp,
                    ),
                name: zod
                    .string()
                    .max(validationWorkflowRetrieveNodeTemplatesItemNameMax),
                description: zod
                    .string()
                    .max(
                        validationWorkflowRetrieveNodeTemplatesItemDescriptionMax,
                    )
                    .optional(),
                roles_required: zod
                    .array(
                        zod.strictObject({
                            name: zod.string(),
                            id: zod.number(),
                        }),
                    )
                    .nullable(),
                can_skip_previous_nodes: zod.boolean().optional(),
            }),
        )
        .nullable(),
    has_processes: zod
        .boolean()
        .describe(
            'True if the workflow has past or ongoing validation processes',
        ),
});

export type ValidationWorkflowRetrieve = zod.input<
    typeof ValidationWorkflowRetrieve
>;
export type ValidationWorkflowRetrieveOutput = zod.output<
    typeof ValidationWorkflowRetrieve
>;
